import AuthenService from "./user/authenService";
import AccountService from "./account/accountService";
import DepartmentService from "./department/departmentService";
import RevenueDeductService from "./revenueDeduct/revenueDeductService";
import PositionService from "./position/positionService";
import EmployeeService from "./employee/employeeService";
import BankService from "./bank/bankService";
import SalaryService from "./salary/salaryService";
import StatementService from "./statement/statementService";
import SettingService from "./setting/settingService";
import MerchantService from "./merchant/merchantService";
import ContactService from "./contact/contactService";
import ExportService from "./export/exportService";
import UserService from "./user/userService";
import DashBoardService from "./dashBoard/dashBoardService";
export default {
  AuthenService,
  AccountService,
  DepartmentService,
  RevenueDeductService,
  PositionService,
  EmployeeService,
  BankService,
  SalaryService,
  StatementService,
  SettingService,
  MerchantService,
  ContactService,
  ExportService,
  UserService,
  DashBoardService,
};
